import { Outlet } from 'react-router-dom'
import { SubNavigation } from '@/components/ui/SubNavigation'
import { Building2, Workflow } from 'lucide-react'

export function AdminLayout() {
  return (
    <>
      <SubNavigation
        rootLabel="Administration"
        children={[
          { label: 'Organizations', to: '/admin/organizations', icon: <Building2 /> },
          { label: 'Workflows', to: '/admin/workflows', icon: <Workflow /> },
        ]}
      />
      <Outlet />
    </>
  )
}
